import { api } from "./api";

export const GetManegment = async (data) => {
  return await api.get("/role/admin/management/list", data);
};

export const GetRoute = async (data) => {
  return await api.get(`/role/admin/management/route/list`, data);
};

export const GetRole = async (data) => {
  return await api.get(`/role/admin/roles`, data);
};

export const AssignRole = async (data) => {
  return await api.post(`/role/admin/create`, data);
};

export const RoleView = async (addURL = ``) => {
  let url = `/role/all/permissions/list?${addURL}`;
  return await api.get(url);
};

export const RoleUpdate = async (data) => {
  return await api.post(`/role/admin/update`, data);
};

export const RoleDelete = async (addURL = "") => {
  let url = `/role/admin/delete?${addURL}`;
  return await api.post(url);
};

export const GetUser = async (addURL = "") => {
  let url = `/users?${addURL}`;
  return await api.get(url);
};
